<template>
  <div class="body">
    <loading
      :active.sync="loading"
      color="#2c3e50"
    />
    <div class="cs-body-header">
      <h2>Carrinho</h2>
    </div>
    <div
      v-if="cart"
      class="cs-cart"
    >
      <CartItem
        v-for="(cartItem, index) in cart.cartItems"
        :key="index"
        :cart-item="cartItem"
        class="cs-products"
      />
      <div class="cs-subtotal">
        <div class="cs-subtotal-wrapper">
          <span class="cs-subtotal-label">Subtotal</span>
          <span class="cs-subtotal-value">{{ subtotal }}</span>
        </div>
      </div>
      <Shipping v-if="requireShipping" />
      <div class="cs-total">
        <div class="cs-total-wrapper">
          <span class="cs-total-label"><strong>TOTAL</strong></span>
          <span class="cs-total-value"><strong>{{ total }}</strong></span>
        </div>
      </div>
    </div>
    <div class="cs-cart-buttons">
      <div class="cs-store-link-container">
        <a
          class="cs-store-link"
          :href="siteUrl"
        >
          Continuar comprando no site
        </a>
      </div>
      <Purchase />
    </div>
  </div>
</template>

<script>
import 'vue-loading-overlay/dist/vue-loading.css'
import CartItem from './components/CartItem'
import Loading from 'vue-loading-overlay'
import Purchase from './components/Purchase'
import Shipping from './components/Shipping'
import currencyMixin from '@/mixins/currency'
import { mapGetters, mapState } from 'vuex'

let CartComponent = {
  name: 'Cart',

  components: {
    CartItem,
    Loading,
    Purchase,
    Shipping
  },

  mixins: [currencyMixin],

  computed: {
    ...mapGetters('cart', ['requireShipping']),
    ...mapState('cart', ['cart', 'loading']),
    ...mapState('shipping', ['shipping']),

    cartItems() {
      return this.cart.cartItems || []
    },

    shippingPrice() {
      return this.shipping.price || 0
    },

    siteUrl() {
      return `https://${this.cart.siteUrl}`
    },

    subtotal() {
      return this.parseCurrency(subtotal(this.cartItems))
    },

    total() {
      const result = subtotal(this.cartItems) + this.shippingPrice

      return this.parseCurrency(result)
    }
  },

  created() {
    const id = this.$route.params.id

    this.$store.dispatch('cart/fetchCart', { id })
  }
}

function cartItemUnitPrice({ offerPrice: offerPrice, price: price }) {
  return offerPrice || price
}

function subtotal(cartItems) {
  return cartItems.reduce((acc, cartItem) => {
    return acc + (cartItem.quantity * cartItemUnitPrice(cartItem.product))
  }, 0)
}

export default CartComponent
</script>

<style lang="scss">
@import '@/assets/styles/_mixins.scss';

%cs-font-style {
  color: #666;
  font-family: 'OpenSans-Regular', 'Open Sans';
  font-style: normal;
  font-weight: 400;
}

%cs-border-bottom {
  border-bottom-color: #d7d7d7;
  border-bottom-style: inset;
  border-bottom-width: thin;
  width: 93%;
  margin: 0 auto;

}

%cs-info-wrapper {
  display: flex;
  justify-content: space-between;
}

.cs-body-header {
  @include desktop-up { margin: 5% 0 2% 11%; }
  display: flex;
  align-items: center;
  margin: 5% 0 2% 3%;

  img {
    @include desktop-up { height: 30px; width: 35px; }
    height: 20px;
    width: 25px;
  }

  div {
    @include desktop-up { font-size: 20px; }
    font-size: 18px;
    margin-left: 5px;
  }
}

.cs-cart {
  @include desktop-up { margin: 1% 10%; }
  box-shadow: 1px 1px 5px rgb(204, 204, 204);
  box-sizing: border-box;
  margin: 2%;

  .cs-products {
    @extend %cs-border-bottom;
  }

  .cs-subtotal {
    @extend %cs-border-bottom;
    display: flex;
    padding: 2%;
    height: 30px;
    align-items: center;
    justify-content: flex-end;

    .cs-subtotal-wrapper {
      @extend %cs-info-wrapper;
      @include phone-only { width: 100%; }
      @include tablet-portrait-up { width: 32%; }
      @include tablet-landscape-up { width: 25%; }
    }
  }

  .cs-total {
    background-color: #f4f5f6;
    display: flex;
    font-size: 18px;
    justify-content: flex-end;
    align-items: center;
    padding: 0 3%;
    height: 70px;

    .cs-total-wrapper {
      @extend %cs-info-wrapper;
      @include phone-only { width: 100%; }
      @include tablet-portrait-up { width: 32%; }
      @include tablet-landscape-up { width: 25%; }
    }
  }
}

.cs-cart-buttons {
  @include tablet-portrait-up { margin: 3%; }
  @include tablet-landscape-up {
    margin: 1% 3%;
    align-items: baseline;
    justify-content: space-between;
    flex-wrap: nowrap;
    flex-direction: row;
  }
  @include desktop-up { margin: 1% 10%; }
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: wrap;
  align-items: center;

  .cs-store-link-container {
    @include tablet-landscape-up { text-align: left; }

    .cs-store-link {
      font-size: 18px;
      text-decoration: none;
      color: #4291BE;
    }
  }
}
</style>
